<script setup>
import CFCustomSpinner from '@/shared/components/CFCustomSpinner.vue';
</script>

<template>
    <div
        data-loading="true"
        class="fixed inset-0 z-1000 flex flex-col items-center justify-center bg-black"
    >
        <img
            src="/Cyberfusion_Logo_White.svg"
            alt="Logo"
            class="mb-8 h-12"
        />
        <CFCustomSpinner
            color="white"
            size="lg"
        />
    </div>
</template>
